import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconGreaterThan(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.26006 4.32733C8.88855 4.73599 8.91867 5.36844 9.32733 5.73995L14.0134 10L9.32733 14.2601C8.91867 14.6316 8.88855 15.264 9.26006 15.6727C9.63157 16.0813 10.264 16.1115 10.6727 15.7399L16.1727 10.7399C16.3811 10.5504 16.5 10.2818 16.5 10C16.5 9.71826 16.3811 9.44959 16.1727 9.26007L10.6727 4.26007C10.264 3.88856 9.63157 3.91868 9.26006 4.32733Z"
        fill="currentColor"
      />
      <path
        d="M19 18C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H5C4.44771 20 4 19.5523 4 19C4 18.4477 4.44771 18 5 18H19Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
